import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpParamsService } from '../../../../../shared/services/http-params.service';
import {
  ScanLocation,
  WarehouseLocationLiteResponse,
  WarehouseLocationModel,
  WarehouseLocationResponse,
} from '../models/location.models';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly BASE: string = `${environment.inventoryApiUrl}/WarehouseLocations`;
  private readonly GET_ALL = (): string => `${this.BASE}`;
  private readonly GET_ALL_LITE = (): string => `${this.BASE}/Lite`;
  private readonly GET_BY_ID = (id: number): string => `${this.BASE}/${id}`;
  private readonly CREATE = (): string => `${this.BASE}`;
  private readonly UPDATE = (id: number): string => `${this.BASE}/${id}`;
  private readonly DELETE = (id: number): string => `${this.BASE}/${id}`;
  private readonly BULKDELETE = (): string => `${this.BASE}/Bulk`;

  constructor(
    private readonly http: HttpClient,
    private httpParamsService: HttpParamsService,
  ) {}

  getAllWarehouseLocations(
    queryParams: Record<string, any>,
  ): Observable<WarehouseLocationResponse> {
    queryParams = { ...queryParams, ExcludeScanPull: false };
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseLocationResponse>(this.GET_ALL(), { params });
  }

  getAllWarehouseLocationsLite(
    queryParams: Record<string, any>,
  ): Observable<WarehouseLocationLiteResponse[]> {
    queryParams = { ...queryParams, ExcludeScanPull: false };
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseLocationLiteResponse[]>(this.GET_ALL_LITE(), { params });
  }

  createWarehouseLocation(warehouseLocation: WarehouseLocationModel) {
    return this.http.post(this.CREATE(), warehouseLocation);
  }

  getWarehouseLocationById(id: number) {
    return this.http.get<any>(this.GET_BY_ID(id));
  }

  updateWarehouseLocation(id: number, warehouseLocation: WarehouseLocationModel) {
    return this.http.put(this.UPDATE(id), warehouseLocation);
  }

  deleteWarehouseLocation(id: number) {
    return this.http.delete(this.DELETE(id));
  }

  deleteBulkWarehouseLocation(queryParams: Record<string, any>) {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.delete(this.BULKDELETE(), { params });
  }

  searchWarehouseLocation(queryParams: Record<string, any>) {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseLocationResponse>(this.GET_ALL(), { params });
  }

  getWarehouseLocationsByWarehouseId(queryParams: Record<string, any>) {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseLocationResponse>(this.GET_ALL(), { params });
  }

  getWarehouseLocationsByWarehouseZoneId(queryParams: Record<string, any>) {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseLocationResponse>(this.GET_ALL(), { params });
  }

  getWarehouseLocationsByZoneAndWarehouseId(queryParams: Record<string, any>) {
    const params: HttpParams = this.httpParamsService.buildCleanHttpParams(queryParams);
    return this.http.get<WarehouseLocationResponse>(this.GET_ALL(), { params });
  }

  ValidateScanLocation(data: ScanLocation) {
    const url = `${this.BASE}/Scan`;
    return this.http.post<WarehouseLocationModel>(url, data);
  }
}
